import { IconCircleCheckFilled } from '@tabler/icons-react'
import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './AuthenticationDrawer.module.scss'

interface PasswordValidationsContainerProps {
  value: string
}

export const PasswordValidationsContainer = ({
  value,
}: PasswordValidationsContainerProps) => {
  const minChar = 8
  const passwordConditions = [
    {
      text: 'Password must contain at least 8 characters',
      satisfied: value?.length >= minChar,
    },
    {
      text: 'Password must contain 1 lowercase letter',
      satisfied: value && /[a-z]/.test(value),
    },
    {
      text: 'Password must contain 1 uppercase letter',
      satisfied: value && /^[^A-Z]*[A-Z]/.test(value),
    },
    {
      text: 'Password must contain 1 symbol',
      satisfied: value && /[!_@#$%^&*()\[\]{};:'",.<>\/?\\|]/.test(value),
    },
  ]

  return (
    <div className='flex flex-col gap-4'>
      {passwordConditions.map((condition) => {
        const colorsBasedOnCondition = condition.satisfied
          ? styles.validationSuccess
          : styles.validationBase
        return (
          <div key={condition.text} className='flex gap-2 items-center'>
            <IconCircleCheckFilled
              size={18}
              className={colorsBasedOnCondition}
            />
            <Typography
              tag={TypographyTag.div}
              variant={TypographyVariant.BodySmallBold}
              className={colorsBasedOnCondition}>
              {condition.text}
            </Typography>
          </div>
        )
      })}
    </div>
  )
}
